import * as React from 'react';

function SvgTumblrColour(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="TumblrColour_svg__a"
        maskUnits="userSpaceOnUse"
        x={2}
        y={2}
        width={26}
        height={26}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 2.178h25.79v25.79H2V2.179z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#TumblrColour_svg__a)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.64 2.178H7.15C4.318 2.178 2 4.496 2 7.328v15.49c0 2.833 2.318 5.15 5.15 5.15h15.49c2.832 0 5.15-2.317 5.15-5.15V7.329c0-2.832-2.318-5.15-5.15-5.15z"
          fill="#001935"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.337 23.106H16.62c-2.447 0-4.27-1.26-4.27-4.271V14.01h-2.225v-2.612c2.448-.635 3.471-2.742 3.59-4.565h2.54v4.141h2.965v3.036h-2.965v4.2c0 1.26.636 1.694 1.647 1.694h1.436v3.2z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgTumblrColour;
